import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2d86de6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scanLoginContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "scanLoginUrl",
  alt: "app login code"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "maskView"
}
const _hoisted_4 = { class: "errorText" }
const _hoisted_5 = { class: "scanLoginText" }
const _hoisted_6 = { class: "app" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orContainer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "leftSplitLine" }),
  /*#__PURE__*/_createElementVNode("span", null, "or"),
  /*#__PURE__*/_createElementVNode("div", { class: "rightSplitLine" })
], -1))

import {
  onMounted,
  onUnmounted,
  ref,
} from 'vue';
import {transformI18n} from '@/langs/i18n';
import QRCode from 'qrcode';
import {webCodeAcquire, webCodeCheckLogin} from '@/api/user';

type VoidNoop = (arg0?: Error) => void


export default /*#__PURE__*/_defineComponent({
  __name: 'scanLogin',
  props: {
  sysNameVal: {
    type: String,
    default: '',
  },
},
  emits: ['email-login', 'login-success'],
  setup(__props, { emit }) {



let timeInterval = null;
let codeKey;
const isCodeExpire = ref(false);
const loading = ref(true);



onMounted(() => {
  isCodeExpire.value = false;
  codeAcquire();
});

onUnmounted(() => {
  codeKey = undefined;
  isCodeExpire.value = false;
  if (timeInterval) {
    clearTimeout(timeInterval);
  }
  loading.value = true;
});

const codeAcquire = async () => {
  loading.value = true;
  try {
    const res = await webCodeAcquire();
    const opts = {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      quality: 1,
      margin: 0,
    };
    codeKey = res.data?.data?.token;
    const scanLoginUrl = `https://d.solar.eonlandfuture.com?token=${res.data?.data?.token}`;
    QRCode.toDataURL(scanLoginUrl, opts, (err, url) => {
      document.getElementById('scanLoginUrl').src = url;
    });
    isCodeExpire.value = false;
    setTimeInterval(codeCheckLogin, 1000);
  } catch {
    // do nothing.
  } finally {
    loading.value = false;
  }
};

const codeCheckLogin = async () => {
  if (!codeKey) {
    return;
  }
  try {
    const res = await webCodeCheckLogin({
      codeKey,
    });
    if (res.data?.data?.token) {
      emit('login-success', { token: res.data.data.token, serverUrl: res.data.data.serverUrl });
    }
  } catch ({data, status, hideNormalError}) {
    if (hideNormalError) {
      hideNormalError();
    }
    const codeExpire = status === 400 && data && data.length > 0 && data[0].errCode === 'webCodeCheckLogin_0';
    if (codeExpire) {
      isCodeExpire.value = codeExpire;
      if (timeInterval) {
        clearTimeout(timeInterval);
      }
    }
  }
};

const setTimeInterval = (fn: VoidNoop, millisec: number) => {
  if (timeInterval) {
    clearTimeout(timeInterval);
  }
  const interval = () => {
    timeInterval = setTimeout(interval, millisec);
    fn();
  };
  timeInterval = setTimeout(interval, millisec);
};

const handleEmailLogin = () => {
  emit('email-login');
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isCodeExpire.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(transformI18n)('login.codeExpired')), 1),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: codeAcquire
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(transformI18n)('login.refreshQrcode')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createTextVNode(_toDisplayString(_unref(transformI18n)('login.open')) + " ", 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(transformI18n)('login.EONPowerlandApp', {sysName: __props.sysNameVal})), 1),
      _createTextVNode(" " + _toDisplayString(_unref(transformI18n)('login.openScanLogin')), 1)
    ]),
    _hoisted_7,
    _createElementVNode("div", {
      onClick: handleEmailLogin,
      onKeydown: handleEmailLogin,
      class: "emailLoginText"
    }, _toDisplayString(_unref(transformI18n)('login.emailLogin')), 33)
  ]))
}
}

})